//
// Layout Panel
//

layoutPanel = {};

layoutPanel.create = function () {
  var panel = new PIXI.Container();

  panel.highlightGraphic = new PIXI.Graphics();

  panel.button = undefined;
  panel.manipButtons = {};
  panel.selectedObject = undefined;
  panel.selectedObjectIsChild = false;
  panel.searchString = "";
  panel.positioning = false;
  panel.scaling = false;
  panel.rotating = false;
  panel.fineMovement = false;

  panel.addButton = function (
    x,
    y,
    width,
    height,
    colour,
    text,
    fontDefinition
  ) {
    var buttonGraphic = new PIXI.Graphics();
    buttonGraphic.lineStyle(1, "0x000000", 1.0);
    buttonGraphic.beginFill(colour, 1.0);
    buttonGraphic.drawRect(
      x / resourceManager.selectedAssetResolution.scaleFactor,
      y / resourceManager.selectedAssetResolution.scaleFactor,
      width / resourceManager.selectedAssetResolution.scaleFactor,
      height / resourceManager.selectedAssetResolution.scaleFactor
    );
    buttonGraphic.endFill();
    buttonGraphic.interactive = true;
    buttonGraphic.visible = false;

    var textObj = resourceManager.createObject(
      "text",
      "buttonText_" + text,
      "layoutPanel",
      {
        text: text,
        x: x + width / 2,
        y: y + height / 2,
        fontDefinition: fontDefinition,
        maxWidth: width,
        anchor: 0.5,
      }
    );
    buttonGraphic.addChild(textObj);
    this.addChild(buttonGraphic);
    return buttonGraphic;
  };

  panel.open = function () {
    this.selectedObject = undefined;
    this.selectNextObject();
    this.highlightGraphic.visible = true;
    this.button.mousedown = this.button.touchstart = this.close.bind(this);

    this.manipButtons.positioner.visible = true;
    this.manipButtons.scaler.visible = true;
    this.manipButtons.rotator.visible = true;
  };

  panel.close = function () {
    this.selectObject(this);
    this.searchString = "";
    this.selectedObjectIsChild = false;
    this.highlightGraphic.visible = false;
    this.button.mousedown = this.button.touchstart = this.open.bind(this);

    this.positioning = false;
    this.scaling = false;
    this.rotating = false;

    this.manipButtons.positioner.visible = false;
    this.manipButtons.positioner.scale.set(1, 1);
    this.manipButtons.scaler.visible = false;
    this.manipButtons.scaler.scale.set(1, 1);
    this.manipButtons.rotator.visible = false;
    this.manipButtons.rotator.scale.set(1, 1);

    var keys = Object.keys(resourceManager.generatedResources);
    var layouts = Object.keys(resourceManager.configuration.layouts);
    for (var i = 0; i < keys.length; ++i) {
      var object = resourceManager.generatedResources[keys[i]].object;
      for (var j = 0; j < layouts.length; ++j) {
        var properties = object.Props[layouts[j]];
        if (
          properties !== undefined &&
          properties.dirty !== undefined &&
          properties.dirty
        ) {
          //OG: This variable will not exist if the rotation hasn't been set/changed
          var rotation =
            properties.rotation === undefined ? 0 : properties.rotation;

          //"landscape_default": { "position": { "x": 0, "y": 0 }, "scaleX": 1.00, "scaleY": 1.00, "rotation": 0.000000 },
          console.log(
            object.name +
              ': "' +
              layouts[j] +
              '": ' +
              '{ "position": { "x": ' +
              properties.position.x +
              ', "y": ' +
              properties.position.y +
              " }, " +
              '"scaleX": ' +
              properties.scaleX.toFixed(2) +
              ', "scaleY": ' +
              properties.scaleY.toFixed(2) +
              ", " +
              '"rotation": ' +
              rotation.toFixed(6) +
              " },"
          );
          properties.dirty = false;
        }
      }
    }
  };

  panel.isValidNextObject = function (key) {
    if (this.selectedObjectIsChild) {
      var index = key.indexOf(this.searchString);
      if (index === -1) {
        return false;
      }
      return key.indexOf(":", this.searchString.length) === -1;
    }

    return key.indexOf(":") === -1;
  };

  panel.selectNextObject = function () {
    var keys = Object.keys(resourceManager.generatedResources);
    var i =
      this.selectedObject === undefined
        ? 0
        : keys.indexOf(this.selectedObject.name) + 1;
    if (i > keys.length) {
      i = 0;
    }

    var object = undefined;
    while (true) {
      if (i >= keys.length) {
        i = 0;
        if (this.selectedObjectIsChild) {
          break;
        }
      }

      if (this.isValidNextObject(keys[i])) {
        object = resourceManager.generatedResources[keys[i]].object;
        if (object.visible === true) {
          break;
        }
      }

      ++i;
    }

    if (object !== undefined) {
      this.selectObject(object);
    }
  };

  panel.selectPreviousObject = function () {
    var keys = Object.keys(resourceManager.generatedResources);
    var i =
      this.selectedObject === undefined
        ? 0
        : keys.indexOf(this.selectedObject.name) - 1;
    if (i <= 0) {
      i = keys.length - 1;
    }

    var object = undefined;
    while (true) {
      if (i < 0) {
        i = keys.length - 1;
        if (this.selectedObjectIsChild) {
          break;
        }
      }

      if (this.isValidNextObject(keys[i])) {
        object = resourceManager.generatedResources[keys[i]].object;
        if (object.visible === true) {
          break;
        }
      }

      --i;
    }

    if (object !== undefined) {
      this.selectObject(object);
    }
  };

  panel.selectParentObject = function () {
    if (
      this.selectedObject !== undefined &&
      this.selectedObject.parent !== undefined
    ) {
      var keys = Object.keys(resourceManager.generatedResources);
      var parentName = this.selectedObject.name.substr(
        0,
        this.selectedObject.name.lastIndexOf(":")
      );

      if (keys.indexOf(parentName) !== -1) {
        this.selectObject(
          resourceManager.generatedResources[parentName].object
        );
        this.searchString = this.selectObject.name + ":";

        parentName = this.selectedObject.name.substr(
          0,
          this.selectedObject.name.lastIndexOf(":")
        );
        if (keys.indexOf(parentName) === -1) {
          this.selectedObjectIsChild = false;
        }
        return;
      }
    }

    this.close();
  };

  panel.selectChildObject = function () {
    if (
      this.selectedObject !== undefined &&
      this.selectedObject.children.length > 0
    ) {
      var keys = Object.keys(resourceManager.generatedResources);
      var searchString = this.selectedObject.name + ":";
      var object = undefined;

      for (
        var i = keys.indexOf(this.selectedObject.name) + 1;
        i < keys.length;
        ++i
      ) {
        if (keys[i].indexOf(searchString) === -1) {
          object = undefined;
          break;
        } else {
          object = resourceManager.generatedResources[keys[i]].object;
          if (object.visible === true) {
            break;
          }
        }
      }

      if (object !== undefined) {
        this.searchString = searchString;
        this.selectObject(object);
        this.selectedObjectIsChild = true;
      }
    }
  };

  panel.selectObject = function (object) {
    console.log("Selected object: " + object.name);
    this.selectedObject = object;
    this.selectedObject.addChild(this.highlightGraphic);
    this.highlightGraphic.clear();
    this.highlightGraphic.lineStyle(1, "0x000000", 1.0);
    this.highlightGraphic.beginFill("0x00FF00", 0.4);

    var size = {
      width: object.width / object.scale.x || 100,
      height: object.height / object.scale.y || 100,
    };
    var offset =
      object._anchor === undefined
        ? { x: 0, y: 0 }
        : {
            x: -(size.width * object._anchor.x),
            y: -(size.height * object._anchor.y),
          };

    this.highlightGraphic.drawRect(offset.x, offset.y, size.width, size.height);
    this.highlightGraphic.endFill();
    this.highlightGraphic.updateTransform();
  };

  panel.scaleDownX = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.scaleX -= this.fineMovement ? 0.01 : 0.1;
      this.selectedObject.scale.x = properties.scaleX;
      properties.dirty = true;
    }
  };
  panel.scaleUpX = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.scaleX += this.fineMovement ? 0.01 : 0.1;
      this.selectedObject.scale.x = properties.scaleX;
      properties.dirty = true;
    }
  };

  panel.scaleDownY = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.scaleY -= this.fineMovement ? 0.01 : 0.1;
      this.selectedObject.scale.y = properties.scaleY;
      properties.dirty = true;
    }
  };

  panel.scaleUpY = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.scaleY += this.fineMovement ? 0.01 : 0.1;
      this.selectedObject.scale.y = properties.scaleY;
      properties.dirty = true;
    }
  };

  panel.moveLeft = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.position.x -= this.fineMovement ? 1 : 10;
      this.selectedObject.position.setX(properties.position.x);
      properties.dirty = true;
    }
  };

  panel.moveRight = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.position.x += this.fineMovement ? 1 : 10;
      this.selectedObject.position.setX(properties.position.x);
      properties.dirty = true;
    }
  };

  panel.moveDown = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.position.y += this.fineMovement ? 1 : 10;
      this.selectedObject.position.setY(properties.position.y);
      properties.dirty = true;
    }
  };

  panel.moveUp = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      properties.position.y -= this.fineMovement ? 1 : 10;
      this.selectedObject.position.setY(properties.position.y);
      properties.dirty = true;
    }
  };

  panel.rotateClockwise = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      if (properties.rotation === undefined) {
        properties.rotation = 0;
      }

      properties.rotation -= this.fineMovement ? Math.PI / 180 : Math.PI / 18;
      this.selectedObject.rotation = properties.rotation;
      properties.dirty = true;
    }
  };

  panel.rotateAntiClockwise = function () {
    if (this.selectedObject !== undefined) {
      var properties =
        this.selectedObject.Props[layoutController.getCurrentLayout()];
      if (properties.rotation === undefined) {
        properties.rotation = 0;
      }

      properties.rotation += this.fineMovement ? Math.PI / 180 : Math.PI / 18;
      this.selectedObject.rotation = properties.rotation;
      properties.dirty = true;
    }
  };

  return panel;
};

layoutPanel.initialise = function (json, object) {
  object.button = object.addButton(
    0,
    0,
    200,
    100,
    "0xFF0000",
    "Layout",
    json.fontDefinition
  );
  object.button.mousedown = object.button.touchstart = object.open.bind(object);
  object.button.visible = true;

  object.manipButtons = {
    positioner: object.addButton(
      0,
      110,
      95,
      50,
      "0x00FF00",
      "Position",
      json.fontDefinition
    ),
    scaler: object.addButton(
      105,
      110,
      95,
      50,
      "0x0000FF",
      "Scale",
      json.fontDefinition
    ),
    rotator: object.addButton(
      210,
      110,
      95,
      50,
      "0xFF00FF",
      "Rotate",
      json.fontDefinition
    ),
  };

  object.manipButtons.positioner.mousedown =
    object.manipButtons.positioner.touchstart = function () {
      this.positioning = !this.positioning;
      this.scaling = false;
      this.rotating = false;

      this.manipButtons.scaler.scale.set(1, 1);
      this.manipButtons.rotator.scale.set(1, 1);

      if (this.positioning) {
        this.manipButtons.positioner.scale.set(1.5, 1.5);
      } else {
        this.manipButtons.positioner.scale.set(1, 1);
      }
    }.bind(object);

  object.manipButtons.rotator.mousedown =
    object.manipButtons.rotator.touchstart = function () {
      this.positioning = false;
      this.scaling = false;
      this.rotating = !this.rotating;

      this.manipButtons.scaler.scale.set(1, 1);
      this.manipButtons.positioner.scale.set(1, 1);

      if (this.rotating) {
        this.manipButtons.rotator.scale.set(1.5, 1.5);
      } else {
        this.manipButtons.rotator.scale.set(1, 1);
      }
    }.bind(object);

  object.manipButtons.scaler.mousedown = object.manipButtons.scaler.touchstart =
    function () {
      this.positioning = false;
      this.scaling = !this.scaling;
      this.rotating = false;

      this.manipButtons.positioner.scale.set(1, 1);
      this.manipButtons.rotator.scale.set(1, 1);

      if (this.scaling) {
        this.manipButtons.scaler.scale.set(1.5, 1.5);
      } else {
        this.manipButtons.scaler.scale.set(1, 1);
      }
    }.bind(object);

  Reflex.developerModeData.keyDownCallbacks.push(
    function (keycode) {
      switch (keycode) {
        case 37: {
          // Left Arrow Key
          if (this.positioning) {
            this.moveLeft();
          } else if (this.scaling) {
            this.scaleDownX();
          } else if (this.rotating) {
            this.rotateClockwise();
          } else {
            this.selectPreviousObject();
          }
          break;
        }
        case 39: {
          // Right Arrow Key
          if (this.positioning) {
            this.moveRight();
          } else if (this.scaling) {
            this.scaleUpX();
          } else if (this.rotating) {
            this.rotateAntiClockwise();
          } else {
            this.selectNextObject();
          }
          break;
        }
        case 38: {
          // Up Arrow Key
          if (this.positioning) {
            this.moveUp();
          } else if (this.scaling) {
            this.scaleUpY();
          }
          break;
        }
        case 40: {
          // Down Arrow Key
          if (this.positioning) {
            this.moveDown();
          } else if (this.scaling) {
            this.scaleDownY();
          }
          break;
        }
        case 16: {
          // Left Shift key
          this.fineMovement = true;
          break;
        }
        case 13: {
          // Enter key
          this.selectChildObject();
          break;
        }
        case 8: {
          // Backspace key
          this.selectParentObject();
          break;
        }
        default:
          break;
      }
    }.bind(object)
  );

  Reflex.developerModeData.keyUpCallbacks.push(
    function (keycode) {
      switch (keycode) {
        case 16: {
          // Left Shift key
          this.fineMovement = false;
          break;
        }
        default:
          break;
      }
    }.bind(object)
  );
};
layoutPanel.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "layoutPanel",
  layoutPanel.create,
  layoutPanel.initialise,
  layoutPanel.getFilesRequired
);
